import React from 'react';

const YouTubeEmbed = () => {
  return (

<>


<div className="breadcrumbs overlay">
    <div className="container">
      <div className="bread-inner">
        <div className="row">
          <div className="col-12">
            <h2>Videos</h2>
          </div>
        </div>
      </div>
    </div>
  </div>


   <div className='row py-5 g-0 '>
            
            {/* First video */}
            <div className='col-12 col-md-6'>
              <div className="youtube-embed align-items-center">
                <iframe 
                  width="100%" 
                  height="315" 
                  src="https://www.youtube.com/embed/1BBc5QHVZYI?si=gIVC3SptRcK93TMZ&loop=1&playlist=1BBc5QHVZYI" 
                  title="YouTube video player" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerPolicy="strict-origin-when-cross-origin" 
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* Second video */}
            <div className='col-12 col-md-6'>
              <div className="youtube-embed align-items-center">
                <iframe 
                  width="100%" 
                  height="315" 
                  src="https://www.youtube.com/embed/O_663Z5dKlo?si=gpTZxoXlyl3VhViA&loop=1&playlist=O_663Z5dKlo" 
                  title="YouTube video player" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerPolicy="strict-origin-when-cross-origin" 
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* Third video */}
            {/* <div className='col-12 col-md-4'>
              <div className="youtube-embed align-items-center">
                <iframe 
                  width="100%" 
                  height="315" 
                  src="https://www.youtube.com/embed/kgY2OyYE4D4?si=lMxXvKi1G31CsEFb&loop=1&playlist=kgY2OyYE4D4" 
                  title="YouTube video player" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerPolicy="strict-origin-when-cross-origin" 
                  allowFullScreen
                ></iframe>
              </div>
            </div> */}

          </div>
</>
  );
};

export default YouTubeEmbed;
